'use strict';

/**
 *
 * @name: groupEditorial
 *
 */

import DirectiveTemplate from './nn-group-editorial.directive.html';
import './nn-group-editorial.directive.scss';

function GroupEditorialDirective(
  transObject,
  apiPostService,
  $rootScope
) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    transclude: true,
    link: function(scope, element) {

      scope.item = scope.content();

      scope.onAnalyticsClick = post => {
        window._hmt.push(['_trackEvent', '组件', 'click', `parentType=${scope.item.parentType},index=${scope.item.index},moduleId=${scope.item.id},parentSlug=${scope.item.parentSlug || ''}`]);
        $rootScope.analytics.videoAM('group editorial', scope.item.title, post)
      }

      if (!scope.item.jsonData.layout) {

        var rander = Math.ceil(Math.random());

        if (rander === 1) {

          scope.item.jsonData.layout = 'left';
        } else {

          scope.item.jsonData.layout = 'right';
        }
      }

      function terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      if (!scope.item.jsonData.sources ||
        !scope.item.jsonData.sources[0] ||
        (!scope.item.jsonData.sources[0].postId && !scope.item.jsonData.sources[0].order) ||
        (scope.item.jsonData.sources[0].postId && scope.item.jsonData.sources.length !== 5)
      ) {

        return terminate();
      }

      scope.item.jsonData.sources.forEach(function(item, index) {

        if (item.hasOwnProperty('postId')) {

          scope.item.posts.some(function(post) {

            if (post.id === item.postId) {

              post.postIndex = index;
            }
          });

          if (scope.item.jsonData.sources.length - 1 === index) {

            scope.item.posts.sort(function(a, b) {

              return (a.postIndex > b.postIndex) ? 1 : -1;
            });

            runThePosts();
          }
        } else {

          var callOrder = null;
          var categoryId = null;

          if (item.hasOwnProperty('order')) {

            callOrder = item.order;
          }

          if (item.hasOwnProperty('categoryId')) {

            categoryId = item.categoryId;
          }

          apiPostService
            .getPost(categoryId, callOrder, 1, 5)
            .then(function(result) {

              result.data.items.forEach(function(resPost) {

                scope.item.posts.push(resPost);
              });

              runThePosts();
            });
        }
      });

      scope.sortPosts = function(item) {

        var sortIndex = '';
        scope.item.jsonData.sources.some(function(source, index) {

          if (source.postId === item.id) {

            sortIndex = index;
            return true;
          }
          return false;
        });

        return sortIndex;
      };

      function runThePosts() {

        scope.item.posts.forEach(function(post) {

          transObject.translate(post);
          transObject.setBookmark(post);
          transObject.getDuration(post);
          transObject.trueSlug(post);
          transObject.isPublished(post);
        });

        scope.loaded = true;
      }
    }
  };
}

export default GroupEditorialDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-group-editorial/nn-group-editorial.directive.js